import { Component, Fragment, h, Prop } from '@stencil/core';
import { ClickOutside } from '../../../../utils/stencil/clickOutside';

@Component({
  tag: 'rentware-checkout-shipping-template-address',
  shadow: false,
})
export class RentwareCheckoutShippingTemplateAddress {
  @Prop() addressHint: string;
  @Prop() addressLabel: string;
  @Prop() addressInInput: string;
  @Prop() openAddressHint: boolean;
  @Prop() onHintClick: () => void;
  @Prop() closeHint: () => void;
  @Prop() onAddressInput: (e: string) => void;

  @ClickOutside()
  handleClickOutsideHint() {
    this.closeHint();
  }

  render() {
    return (
      <Fragment>
        <rtr-input onInput={e => this.onAddressInput(e.target.value)} type="text" name="address" label={this.addressLabel} value={this.addressInInput} />

        {this.openAddressHint && (
          <div class="AddressHintContainer">
            <div class="AddressHint" onClick={this.onHintClick}>
              {this.addressHint}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}
